import React from "react";

import { useNavigate, useTranslation } from "utils";

import { TERRA_ROUTE } from "consts";

import { Button, Icon, Tooltip } from "components";

export const TerraLauncher = () => {
  const { t } = useTranslation("home");
  const navigate = useNavigate();

  return (
    // the tooltip anchors to its wrapper, so the wrapper carries the fixed position
    <Tooltip variant="neutral" className="terra-launcher" title={t("agronomist.terra.cta")}>
      <Button
        dataTestId="terra-launcher"
        type="primary"
        className="terra-launcher-button"
        mixpanelText="home-terra-launcher"
        aria-label={t("agronomist.terra.cta")}
        onClick={() => navigate(TERRA_ROUTE)}
      >
        <Icon iconName="klim/magic" size="m" />
      </Button>
    </Tooltip>
  );
};
